import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'

import TagsEmptyResultGuard from './TagsEmptyResultGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicInaccessibleGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <TagsEmptyResultGuard widgetId={widgetId}>{children}</TagsEmptyResultGuard>
      </TopicIndexNotReadyGuard>
    </TopicInaccessibleGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
